import Settings from 'core/settings'

interface SprigSettings {
  enabled?: boolean
  environment_id?: string
}

const getSprigSettings = (): SprigSettings => (Settings as { sprig?: SprigSettings }).sprig ?? {}

/**
 * Payload for identifyAndTrack. Use userId (Segment/compute id), not uuid, so Sprig
 * stays aligned with the rest of the analytics pipeline.
 */
export interface SprigIdentifyAndTrackPayload {
  eventName: string
  userId?: string | number
  properties?: Record<string, unknown>
  anonymousId?: string
  metadata?: Record<string, unknown>
}

export interface SprigWrapper {
  getInstance: () => Promise<unknown>
  identifyAndTrack: (payload: SprigIdentifyAndTrackPayload) => Promise<void>
  addListener: (...args: unknown[]) => Promise<void>
}

let sprig: unknown

const loadSprig = async (): Promise<unknown> => {
  const sprigSettings = getSprigSettings()
  if (!sprig && sprigSettings.enabled) {
    const module = await import('@sprig-technologies/sprig-browser')
    sprig = module.sprig.configure({ environmentId: sprigSettings.environment_id })
  }

  return sprig
}

interface SprigInstance {
  identifyAndTrack: (payload: SprigIdentifyAndTrackPayload) => void
  addListener: (...args: unknown[]) => void
}

const sprigWrapper: SprigWrapper = {
  getInstance: async () => loadSprig(),
  identifyAndTrack: async (payload: SprigIdentifyAndTrackPayload) => {
    if (getSprigSettings().enabled) {
      (await loadSprig() as SprigInstance).identifyAndTrack(payload)
    }
  },
  addListener: async (...args: unknown[]) => {
    if (getSprigSettings().enabled) {
      (await loadSprig() as SprigInstance).addListener(...args)
    }
  }
}

export const useSprig = (): SprigWrapper => sprigWrapper
